import React from "react";

const StepperControl = ({
  handleClick,
  currentStep,
  steps,
  isNextDisabled,
}) => {
  return (
    <div className="mt-4 mb-8 flex justify-evenly">
      <button
        onClick={() => handleClick()}
        className={`cursor-pointer rounded-xl border-2 border-slate-300 bg-white py-2 px-4 font-semibold uppercase text-slate-400 transition duration-200 ease-in-out hover:bg-slate-700 hover:text-white  ${
          currentStep === 1 ? " cursor-not-allowed opacity-50 " : ""
        }`}
      >
        Back
      </button>

      {currentStep !== steps.length ? (
        <button
          onClick={() => handleClick("next")}
          className={`rounded-lg bg-green-500 py-2 px-4 font-semibold uppercase text-white transition duration-200 ease-in-out hover:bg-slate-700 hover:text-white ${
            isNextDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
          }`}
        >
          Next
        </button>
      ) : (
        <button
          onClick={() => handleClick("confirm")}
          className="cursor-pointer rounded-lg bg-green-500 py-2 px-4 font-semibold uppercase text-white transition duration-200 ease-in-out hover:bg-slate-700 hover:text-white"
        >
          confirm
        </button>
      )}
    </div>
  );
};

export default StepperControl;
